import SubmitContext from 'context/submit/submitContext'
import OatsOatmealProduct from 'models/OatsOatmealProduct'
import React, { useContext, useEffect, useState } from 'react'
import Select from 'react-select'
import { Col, FormGroup, Input, Row, Alert } from 'reactstrap'
import { useFormUtils } from 'views/shared/useFormUtils'
import {
  oatTypeOptions,
  oatCookingTypeOptions,
  oatVarietyOptions,
  packagingInitialState,
} from './constants'
import { Controller, ErrorMessage, useFormContext } from 'react-hook-form'
import { isNotAlpha } from 'context/Utilities'

const OatsOatmealPackage = () => {
  const submitContext = useContext(SubmitContext)

  const { current, setCurrent, updating } = submitContext

  // eslint-disable-next-line no-unused-vars
  const [packaging, setPackaging] = useState(packagingInitialState)

  const { onChange, setSelect, asterisk } = useFormUtils()

  const methods = useFormContext()

  useEffect(() => {
    if (
      current?.category === packagingInitialState.category &&
      current?.subCategory === packagingInitialState.subCategory
    ) {
      const {
        category,
        subCategory,
        GrainSize,
        OatType,
        CookingType,
        OatVariety,
        otherType,
        otherVariety,
      } = current
      setPackaging({
        category,
        subCategory,
        GrainSize,
        OatType: {
          value: OatType || '',
          label: OatType.length > 0 ? OatType : 'Oat Type',
        },
        CookingType: {
          value: CookingType || '',
          label: CookingType.length > 0 ? CookingType : 'Oat Cooking Type',
        },
        OatVariety: {
          value: OatVariety || '',
          label: OatVariety.length > 0 ? OatVariety : 'Oat Variety',
        },
        otherType,
        otherVariety,
      })
    } else if (!updating) {
      setCurrent(OatsOatmealProduct)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [current])

  useEffect(() => {
    if (updating) {
      if (current?.OatVariety === 'Other') {
        methods.setValue('otherVariety', current.otherVariety)
      }
      if (current?.OatType === 'Other') {
        methods.setValue('otherType', current.otherType)
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [updating])

  return (
    <Row>
      <Col xs={6}>
        <p>
          <strong>Oat Type {asterisk}</strong>
        </p>
        <Controller
          as={Select}
          className="react-select primary"
          classNamePrefix="react-select"
          options={oatTypeOptions}
          name="OatType"
          control={methods.control}
          rules={{ required: true }}
          placeholder={'Select Oat Type'}
          onChange={([selected]) => {
            setSelect(selected, 'OatType')
            return selected
          }}
        />
        <p className={'text-danger'}>
          <ErrorMessage
            errors={methods.errors}
            name="OatType"
            message={'⚠ This selection is required.'}
            as={<Alert color={'danger'} className={'mt-3'} />}
          />
        </p>
        {current?.OatType === 'Other' && (
          <FormGroup>
            <p>
              <strong>Other Type (Please Specify) {asterisk}</strong>
            </p>
            <Controller
              as={Input}
              name="otherType"
              placeholder={'Other Type'}
              defaultValue={current?.otherType}
              control={methods.control}
              rules={{
                required: true,
                maxLength: {
                  value: 15,
                  message: '⚠ Other Type exceeds 15 characters.',
                },
              }}
              onKeyDown={e => {
                if (isNotAlpha(e.key) && e.key !== ' ') {
                  e.preventDefault()
                }
              }}
              onChange={([event]) => {
                onChange(event)
                return event
              }}
            />
            <p className={'text-danger'}>
              <ErrorMessage
                errors={methods.errors}
                name="otherType"
                message={'Other type is required.'}
                as={<Alert color={'danger'} className={'mt-3'} />}
              />
            </p>
          </FormGroup>
        )}
        <FormGroup>
          <p>
            <strong>Size {asterisk}</strong>
          </p>
        </FormGroup>
        <Input defaultValue={'16 ounces'} disabled />
        <br />
      </Col>
      <Col xs={6}>
        <p>
          <strong>Variety {asterisk}</strong>
        </p>
        <Controller
          as={Select}
          className="react-select primary"
          classNamePrefix="react-select"
          options={oatVarietyOptions}
          name="OatVariety"
          control={methods.control}
          rules={{ required: true }}
          placeholder={'Select Oat Variety'}
          onChange={([selected]) => {
            setSelect(selected, 'OatVariety')
            return selected
          }}
        />
        <p className={'text-danger'}>
          <ErrorMessage
            errors={methods.errors}
            name="OatVariety"
            message={'⚠ This selection is required.'}
            as={<Alert color={'danger'} className={'mt-3'} />}
          />
        </p>
        {current?.OatVariety === 'Other' && (
          <FormGroup>
            <p>
              <strong>Other Variety (Please Specify) {asterisk}</strong>
            </p>
            <Controller
              as={Input}
              name="otherVariety"
              placeholder={'Other Variety'}
              defaultValue={current?.otherVariety}
              control={methods.control}
              rules={{
                required: true,
                maxLength: {
                  value: 15,
                  message: '⚠ Other Variety exceeds 15 characters.',
                },
              }}
              onKeyDown={e => {
                if (isNotAlpha(e.key) && e.key !== ' ') {
                  e.preventDefault()
                }
              }}
              onChange={([event]) => {
                onChange(event)
                return event
              }}
            />
            <p className={'text-danger'}>
              <ErrorMessage
                errors={methods.errors}
                name="otherVariety"
                message={'Other variety is required.'}
                as={<Alert color={'danger'} className={'mt-3'} />}
              />
            </p>
          </FormGroup>
        )}
        <p>
          <strong>Cooking Type {asterisk}</strong>
        </p>
        <Controller
          as={Select}
          className="react-select primary"
          classNamePrefix="react-select"
          options={oatCookingTypeOptions}
          name="CookingType"
          control={methods.control}
          rules={{ required: true }}
          placeholder={'Select Oat Cooking Type'}
          onChange={([selected]) => {
            setSelect(selected, 'CookingType')
            return selected
          }}
        />
        <p className={'text-danger'}>
          <ErrorMessage
            errors={methods.errors}
            name="CookingType"
            message={'⚠ This selection is required.'}
            as={<Alert color={'danger'} className={'mt-3'} />}
          />
        </p>
      </Col>
    </Row>
  )
}

export default OatsOatmealPackage
